import React from 'react'
import {Form, Button, Segment, Label, List, ListItem, Message, Confirm} from 'semantic-ui-react'
import {createAPIClient} from '../../../../../services/api'
import {connect} from 'react-redux'
import {getTemplatesAction} from '../../../../../actions/template.action'
const confirmStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}
class LabelPanel extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editing: false,
      errorMessage: undefined,
      openConfirm: false,
      deleteId: undefined,
      newForm: {
        location: this.props.locations[0],
        color: undefined,
        hex_color: undefined,
        name: ''
      },
      editForm: {
        name: '',
        color: undefined,
        hex_color: undefined
      },
      labels: []
    }
  }
  loadLabels () {
    const api = createAPIClient()
    this.props.loadLabels()
    api.get(`/api/labels?template=${this.props.templateId}`)
      .then(result => {
        this.setState({labels: result.data.response.items})
      })
      .catch(error => {
        console.log(error)
      })
  }
  deleteLabel (id) {
    const api = createAPIClient()
    api.delete(`/api/labels/${id}`)
      .then(result => {
        this.loadLabels()
      })
  }
  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.templateId !== this.props.templateId) {
      this.loadLabels()
    }
  }

  componentDidMount () {
    this.loadLabels()
  }
  onNameChange (e) {
    const newForm = this.state.newForm
    newForm.name = e.target.value
    this.setState({newForm})
  }
  onEditNameChange (e) {
    const editForm = this.state.editForm
    editForm.name = e.target.value
    this.setState({editForm})
  }
  colorChange (color, hexColor) {
    const newForm = this.state.newForm
    newForm.color = color
    newForm.hex_color = hexColor
    this.setState({newForm})
  }
  editColorChange (color, hexColor) {
    const editForm = this.state.editForm
    editForm.color = color
    editForm.hex_color = hexColor
    this.setState({editForm})
  }
  onSubmit () {
    const api = createAPIClient()
    if (!this.state.editing) {
      const form = this.state.newForm
      form.template = [this.props.templateId]
      api.post('/api/labels', form)
        .then(result => {
          this.loadLabels()
          this.setState({errorMessage: undefined, editing: false, editForm: {color: undefined, name: ''}, newForm: {location: this.props.locations[0], color: undefined, name: ''}})
        })
        .catch(error => {
          this.setState({errorMessage: 'Color and name fields are required'})
          console.log(error)
        })
    }
  }
  showConfirm (id) {
    this.setState({openConfirm: true, deleteId: id})
  }
  handleCancel () {
    this.setState({openConfirm: false, deleteId: undefined})
  }
  handleConfirm () {
    this.deleteLabel(this.state.deleteId)
    this.setState({openConfirm: false, deleteId: undefined})
  }
  onEditSubmit () {
    const api = createAPIClient()
    if (this.state.editing) {
      const form = this.state.editForm
      api.put(`/api/labels/${form._id}`, form)
        .then(result => {
          this.setState({errorMessage: undefined, editing: false, editForm: {color: undefined, name: ''}, newForm: {location: this.props.locations[0], color: undefined, name: ''}})
          this.loadLabels()
        })
        .catch(error => {
          this.setState({errorMessage: 'Color and name fields are required'})
          console.log(error)
        })
    }
  }
  onCancelEdit () {
    this.setState({editing: false, editForm: {color: undefined, name: ''}, newForm: {location: this.props.locations[0], color: undefined, name: ''}})
  }
  updateLabel (label) {
    const editForm = Object.assign({}, label)
    this.setState({editForm, editing: true })
  }
  setDefaultLabel (label) {
    const api = createAPIClient()
    let templateId = this.props.templateId
    let data
    if (label._id === undefined) {
      data = {default_label: null}
    } else {
      data = {default_label: label._id}
    }
    api.put(`/api/templates/${templateId}`, data)
      .then(result => {
        this.setState({errorMessage: undefined, editing: false, editForm: {color: undefined, name: ''}, newForm: {location: this.props.locations[0], color: undefined, name: ''}})
        this.loadLabels()
        this.props.getTemplatesAction()
      })
      .catch(error => {
        this.setState({errorMessage: 'Error occurred'})
        console.log(error)
      })
  }

  render () {
    let currentTemplate = this.props.templates.filter(e => e._id === this.props.templateId)[0]
    const LinkListing = (
      <List>
        {this.state.labels.map(label => {
          return <ListItem style={{margin: '10px'}} key={label._id}>
            <Label circular color={label.color}>&nbsp;</Label> {label.name} &nbsp;
            <a href='#' onClick={this.updateLabel.bind(this, label)}>Update</a> |&nbsp;
            {currentTemplate.default_label === label._id
              ? <a href='#' onClick={this.setDefaultLabel.bind(this)}>Remove from default </a>
              : <a href='#' onClick={this.setDefaultLabel.bind(this, label)}>Set as default </a>}
             |&nbsp;
            <a href='#' onClick={this.showConfirm.bind(this, label._id)}>Delete</a>
          </ListItem>
        })}
        <Confirm
          style={confirmStyle}
          open={this.state.openConfirm}
          onCancel={this.handleCancel.bind(this)}
          onConfirm={this.handleConfirm.bind(this)}
          content='Are you sure you want to delete this label?'
          confirmButton='Yes'
        />
      </List>
    )
    const buttonStyle = {width: '50px', height: '42px'}
    const newForm = (
      <Form onSubmit={this.onSubmit.bind(this)}>
        {this.state.errorMessage !== undefined ? (
          <Message negative>
            <Message.Header>{this.state.errorMessage}</Message.Header>
          </Message>
        ) : undefined}
        <Form.Group>
          <Form.Input fluid label='Label name' placeholder='Label name' width={3} value={this.state.newForm.name} onChange={this.onNameChange.bind(this)} />
          <Form.Input value={this.state.newForm.color} fluid label='Pick a color' placeholder='First name' width={6}>
            <Button style={buttonStyle} type='button' onClick={this.colorChange.bind(this, 'green', '#28B463')} color='green'> {this.state.newForm.color === 'green' ? 'V' : ' '}</Button>
            <Button style={buttonStyle} type='button' onClick={this.colorChange.bind(this, 'yellow', '#FFC300')} color='yellow'>{this.state.newForm.color === 'yellow' ? 'V' : ' '}</Button>
            <Button style={buttonStyle} type='button' onClick={this.colorChange.bind(this, 'orange', '#E67E22')} color='orange'>{this.state.newForm.color === 'orange' ? 'V' : ' '}</Button>
            <Button style={buttonStyle} type='button' onClick={this.colorChange.bind(this, 'red', '#E74C3C')} color='red'>{this.state.newForm.color === 'red' ? 'V' : ' '}</Button>
            <Button style={buttonStyle} type='button' onClick={this.colorChange.bind(this, 'blue', '#2874A6')} color='blue'>{this.state.newForm.color === 'blue' ? 'V' : ' '}</Button>
          </Form.Input>
        </Form.Group>

        <Form.Button type='submit' primary >Submit</Form.Button>
      </Form>
    )
    const editForm = (
      <Form>
        {this.state.errorMessage !== undefined ? (
          <Message negative>
            <Message.Header>{this.state.errorMessage}</Message.Header>
          </Message>
        ) : undefined}
        <Form.Group>
          <Form.Input fluid label='Label name' placeholder='Label name' width={3} value={this.state.editForm.name} onChange={this.onEditNameChange.bind(this)} />
          <Form.Input fluid label='Pick a color' placeholder='First name' width={6}>
            <Button style={buttonStyle} onClick={this.editColorChange.bind(this, 'green', '#28B463')} color='green'> {this.state.editForm.color === 'green' ? 'V' : ' '}</Button>
            <Button style={buttonStyle} onClick={this.editColorChange.bind(this, 'yellow', '#FFC300')} color='yellow'>{this.state.editForm.color === 'yellow' ? 'V' : ' '}</Button>
            <Button style={buttonStyle} onClick={this.editColorChange.bind(this, 'orange', '#E67E22')} color='orange'>{this.state.editForm.color === 'orange' ? 'V' : ' '}</Button>
            <Button style={buttonStyle} onClick={this.editColorChange.bind(this, 'red', '#E74C3C')} color='red'>{this.state.editForm.color === 'red' ? 'V' : ' '}</Button>
            <Button style={buttonStyle} onClick={this.editColorChange.bind(this, 'blue', '#2874A6')} color='blue'>{this.state.editForm.color === 'blue' ? 'V' : ' '}</Button>
          </Form.Input>
        </Form.Group>
        <Form.Group>
          <Form.Button onClick={this.onCancelEdit.bind(this)}>Cancel</Form.Button>
          <Form.Button primary onClick={this.onEditSubmit.bind(this)}>Submit</Form.Button>
        </Form.Group>
      </Form>
    )
    return (
      <Segment>
        {this.state.editing ? editForm : newForm}
        {LinkListing}
      </Segment>
    )
  }
}
function mapStateToProps (state) {
  return {locations: state.account.user.locations, templates: state.templates.templates}
}

export default connect(mapStateToProps, {getTemplatesAction})(LabelPanel)




// WEBPACK FOOTER //
// ./src/pages/issues/overview/components/labelpanel/index.js